import { isEmpty } from 'lodash-es';

export const shouldRenderField = (isAdminView: boolean, value: unknown) => {
  if (isAdminView) return true;
  if (Array.isArray(value)) return !isEmpty(value);

  return !!value;
};
